//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import UserSelect from './components/userSelect';
import RichEditor from '@/components/richEditor';
import MessageBox from '@/components/messageBox';
import SelectColumn from '@/components/selectColumn';
import InputJson from '@/components/inputJson';
import { arrUnique } from '@/utils/util';
import { mapActions, mapGetters } from 'vuex';
import Clipboard from 'nges-common/src/web/components/Clipboard';
import CodeEditor from './editor';

const ESCAPE_MAP = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
};

export default {
  name: 'NoticeDetail',
  components: {
    UserSelect,
    RichEditor,
    MessageBox,
    SelectColumn,
    InputJson,
    Clipboard,
    CodeEditor,
  },
  data() {
    return {
      labelWidth: '150px',
      id: '',
      // 列表页状态
      listTab: '',
      // 延后userSelect的加载时间确保其能获取初始值
      loading: true,
      // 提交中
      isSubmit: false,
      form: {
        // 模板名称
        name: '',
        // 业务模块
        subject: '',
        // 模版ID
        templateCode: '',
        // 备注
        remark: '',
        // 通知类型
        messagingType: [],
        // 消息类型
        wecomMsgType: '',
        // 站内信类型
        systemMessagingType: '',
        // 接收人设置
        recipientType: 1,
        // 收件人
        recipient: [],
        // 编辑形式
        editorType: 1,
        // 通知标题
        title: '',
        // 通知内容
        content: '',
        // js脚本
        script: '',
        // 腾讯云短信模版id
        sms_template_id: '',
        // 自定义模版变量
        templateVars: {},
        // 通知终端
        platform: [1, 2],
      },
      // 校验规则
      formRule: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        templateCode: [{ required: true, message: '请输入模板ID', trigger: 'blur' }],
        messagingType: [{ required: true, message: '请选择通知类型 ', trigger: 'change' }],
        systemMessagingType: [{ required: true, message: '请选择站内信类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入通知标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入通知内容' },
          {
            validator: (rule, value, callback) => {
              const err = this.validateContent();
              if (err) {
                callback(err);
              } else {
                callback();
              }
            },
          },
        ],
        sms_template_id: [
          { required: true, message: '请输入腾讯云短信模版ID' },
          {
            validator: (rule, value, callback) => {
              if (!/^\d+$/.test(value)) {
                this.canGetSmsTpl = false;
                callback(new Error('请输入纯数字'));
              } else {
                this.canGetSmsTpl = true;
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        templateVars: [
          {
            validator: (rule, value, callback) => {
              const isInvalid = Object.keys(value || {}).some((key) => {
                if (!value[key]) {
                  return true;
                }
              });
              if (isInvalid) {
                callback('请填充完整的变量');
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        platform: [{ required: true, message: '请选择通知终端 ', trigger: 'change' }],
      },
      // 展示选择窗口
      selectVisible: false,
      // 打开选择窗口的按钮
      selectType: 'title',
      editorType: '',
      // 短信变量
      varItem: '',
      // 要应用在编辑器里的模板字符串
      templateStr: '',
      // 自定义变量列表
      templateVar: [],
      // 对象变量列表
      templateMetadataVar: [],
      // 脚本变量列表
      templateScriptVar: [],
      // 站内信类型列表
      systemMessageTypeList: [],
      // 自动复制变量
      copytext: '',
      // 代码输入框配置
      htmlOptions: {
        placeholder: '<html></html>',
        autorefresh: true,
        mode: 'text/html',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      jsOptions: {
        placeholder: 'var a = 1',
        autorefresh: true,
        mode: 'text/javascript',
        matchBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
      },
      // 短信模版loading
      tpmlLoading: false,
      canGetSmsTpl: false,
      currentTpl: {},
    };
  },
  computed: {
    ...mapGetters({
      objectList: 'notice/getObjectList',
    }),
    showObjectList() {
      return this.objectList.map(({ name, display_name }) => {
        return {
          label: display_name ? `${display_name}-${name}` : name,
          value: name,
        };
      });
    },
    needWecom() {
      return this.form.messagingType.includes('wecom');
    },
    needMessage() {
      return this.form.messagingType.includes('sms');
    },
    contentJson() {
      return this.needWecom && this.form.wecomMsgType !== 'text';
    },
    needEmail() {
      return this.form.messagingType.includes('mail');
    },
    needStation() {
      return this.form.messagingType.includes('system');
    },
    // 只选了站内信的时候,需要选择终端
    needPlatform() {
      return this.form.messagingType.length == 1 && this.form.messagingType[0] === 'system';
    },
    needTitle() {
      return this.form.messagingType.some((i) => ['mail', 'wecom', 'system'].includes(i));
    },
    documentLink() {
      if (this.contentJson) {
        switch (this.form.wecomMsgType) {
          case 'miniprogram_notice':
            return 'https://developer.work.weixin.qq.com/document/path/90236#%E5%B0%8F%E7%A8%8B%E5%BA%8F%E9%80%9A%E7%9F%A5%E6%B6%88%E6%81%AF';
          case 'news':
            return 'https://developer.work.weixin.qq.com/document/path/90236#%E5%9B%BE%E6%96%87%E6%B6%88%E6%81%AF';
        }
      }
      return '';
    },
    tmplVars() {
      return Object.keys(this.form.templateVars);
    },
    previewContent() {
      return this.form.content.replaceAll('href="mailto', '');
    },
  },
  watch: {
    // 与富文本编辑器保持一致
    templateStr(newVal) {
      if (this.form.messagingType.includes('wecom')) {
        this.form.content += newVal;
      }
    },
    'form.messagingType'(newVal, oldVal) {
      if (this.loading) return;
      if (!oldVal.includes('wecom') && newVal.includes('wecom')) {
        this.form.wecomMsgType = 'text';
      }
    },
  },
  mounted() {
    this.getObjectList();
    this.getTypeList();
    const { id, listTab } = this.$route.query;

    if (id) {
      this.id = id;
      this.listTab = listTab;
      this.$request({
        url: this.$api.getMessagingTemplate,
        data: {
          template_code: id,
        },
        cb: (data) => {
          this.form.name = data.name;
          this.form.templateCode = data.template_code;
          this.form.remark = data.remark;
          this.form.subject = data.subject;
          this.form.messagingType = data.messaging_type;
          this.form.systemMessagingType = data.system_messaging_type;
          this.form.wecomMsgType = data.wecom_msg_type;
          if (this.needWecom && !this.form.wecomMsgType) {
            this.form.wecomMsgType = 'text';
          }
          this.form.recipientType = data.recipient_type;
          this.form.recipient = data.recipient_list;
          this.form.title = data.title;
          this.form.content = data.content;
          this.form.script = data.script;
          if (this.form.script) this.form.editorType = 2;
          this.form.sms_template_id = data.sms_template_id;
          this.canGetSmsTpl = !!/^\d+$/.test(this.form.sms_template_id);
          this.form.templateVars = (data.sms_params || []).reduce((pre, item, index) => {
            pre[`${index + 1}`] = item;
            return pre;
          }, {});
          this.form.platform = data.platform;
          this.$nextTick(() => {
            this.loading = false;
          });
        },
      });
    } else {
      this.loading = false;
    }
    this.$refs.form.clearValidator();
  },
  methods: {
    ...mapActions({
      getObjectList: 'notice/requestObjectList',
    }),
    escapeHtmlToText(text = '') {
      let newText = text;
      for (const k of Object.keys(ESCAPE_MAP)) {
        newText = newText.replaceAll(k, ESCAPE_MAP[k]);
      }
      return newText;
    },
    submit() {
      if (this.contentJson) {
        try {
          JSON.parse(this.form.content);
        } catch (e) {
          console.log(e);
          this.$message.error('通知内容需要符合JSON格式');
          return;
        }
      }

      this.isSubmit = true;
      this.varCheck();

      const param = {
        name: this.form.name,
        template_code: this.form.templateCode,
        remark: this.form.remark,
        subject: this.form.subject,
        messaging_type: this.form.messagingType,
        system_messaging_type: this.form.systemMessagingType,
        wecom_msg_type: this.needWecom ? this.form.wecomMsgType : '',
        recipient_type: this.form.recipientType,
        recipient_list: this.form.recipient,
        title: this.form.title,
        script: this.form.script,
        content: this.escapeHtmlToText(this.form.content),
        template_var: arrUnique(this.templateVar),
        template_metadata_var: arrUnique(this.templateMetadataVar),
        template_expr_var: arrUnique(this.templateScriptVar),
        sms_params: Object.values(this.form.templateVars),
        platform: this.form.platform,
      };

      if (this.form.messagingType.includes('sms')) {
        param.sms_template_id = this.form.sms_template_id;
      }

      console.log('meow', param);

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$request({
            url: this.id ? this.$api.updateMessagingTemplate : this.$api.addMessagingTemplate,
            data: param,
            cb: () => {
              this.isSubmit = false;
              this.$message.success('保存成功');
              this.$router.push({
                name: 'notice-list',
                query: {
                  listTab: this.listTab,
                },
              });
            },
            fault: () => {
              this.isSubmit = false;
            },
          });
        } else {
          this.isSubmit = false;
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      try {
        const query = {};
        if (this.id) query.listTab = this.listTab;
        this.$refs.messageBox.show({
          title: '提示',
          content: '此操作将不会保存已修改数据?',
          titleIconType: 'warning',
          needCancel: true,
          cancelAction: this.$refs.messageBox.close,
          confirmAction: () => {
            this.$refs.messageBox.close();
            this.$router.push({
              name: 'notice-list',
              query,
            });
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    openSelectColumn(type, editType = '', varItem) {
      this.selectVisible = true;
      this.selectType = type;
      this.editorType = editType;
      this.varItem = varItem;
    },
    // 向编辑器插入字符串
    insertion({ str = '' }) {
      const text = `{{${str}}}`;
      switch (this.selectType) {
        case 'title':
          this.form.title += text;
          break;
        case 'content':
          if (this.editorType) {
            this.templateStr = text;
          } else {
            if (this.contentJson || this.form.editorType === 2) {
              this.copytext = text;
              this.$refs.copy.copy();
            } else {
              this.form.content += text;
            }
          }
          break;
        case 'tmplvars': {
          if (this.varItem) {
            this.form.templateVars[this.varItem] += text;
            this.form.templateVars = { ...this.form.templateVars };
          }
          break;
        }
        default:
          break;
      }
    },
    // 搜寻所有符合逻辑的变量加入变量列表
    varCheck() {
      const templateMetadataVar = [];
      const templateVar = [];
      const templateScriptVar = [];

      const titleTemplateRegexp = /{{([A-z][\w._]*?\.[\w._]*?[A-z])}}/g;
      let titleTemplateResult = titleTemplateRegexp.exec(this.form.title);
      while (titleTemplateResult) {
        console.log('meowtitle1', titleTemplateResult, this.form.title);
        templateMetadataVar.push(titleTemplateResult[1]);
        titleTemplateResult = titleTemplateRegexp.exec(this.form.title);
        console.log('meowtitle12', titleTemplateResult);
      }
      const titleCustomRegexp = /{{(\w+?)}}/g;
      let titleCustomResult = titleCustomRegexp.exec(this.form.title);
      while (titleCustomResult) {
        console.log('meowtitle2', titleCustomResult);
        templateVar.push(titleCustomResult[1]);
        titleCustomResult = titleCustomRegexp.exec(this.form.title);
      }

      const contentTemplateRegexp = /{{([A-z][\w._]*?\.[\w._]*?[A-z])}}/g;
      let contentTemplateResult = contentTemplateRegexp.exec(this.form.content);
      while (contentTemplateResult) {
        console.log('meowcon1', contentTemplateResult);
        templateMetadataVar.push(contentTemplateResult[1]);
        contentTemplateResult = contentTemplateRegexp.exec(this.form.content);
      }
      const contentCustomRegexp = /{{(\w+?)}}/g;
      let contentCustomResult = contentCustomRegexp.exec(this.form.content);
      while (contentCustomResult) {
        console.log('meowcon2', contentCustomResult);
        templateVar.push(contentCustomResult[1]);
        contentCustomResult = contentCustomRegexp.exec(this.form.content);
      }
      if (this.form.editorType === 2) {
        const contentScriptRegexp = /{%(\w+?)%}/g;
        let contentScriptResult = contentScriptRegexp.exec(this.form.content);
        while (contentScriptResult) {
          console.log('meowcon3', contentScriptResult);
          templateScriptVar.push(contentScriptResult[1]);
          contentScriptResult = contentScriptRegexp.exec(this.form.content);
        }
      }

      Object.values(this.form.templateVars).forEach((smsTmplVar) => {
        const smsTmplVarRegexp = /{{([A-z][\w._]*?\.[\w._]*?[A-z])}}/g;
        let smsTmplVarResult = smsTmplVarRegexp.exec(smsTmplVar);
        while (smsTmplVarResult) {
          console.log('meowcon1', smsTmplVarResult);
          templateMetadataVar.push(smsTmplVarResult[1]);
          smsTmplVarResult = smsTmplVarRegexp.exec(smsTmplVar);
        }
        const smsTmplVarCustomRegexp = /{{(\w+?)}}/g;
        let smsTmplVarCustomResult = smsTmplVarCustomRegexp.exec(smsTmplVar);
        while (smsTmplVarCustomResult) {
          console.log('meowcon2', smsTmplVarCustomResult);
          templateVar.push(smsTmplVarCustomResult[1]);
          smsTmplVarCustomResult = smsTmplVarCustomRegexp.exec(smsTmplVar);
        }
      });
      this.templateVar = templateVar;
      this.templateMetadataVar = templateMetadataVar;
      this.templateScriptVar = templateScriptVar;
    },
    getTypeList() {
      this.$request({
        url: this.$api.metaGetObjectByName,
        data: {
          objects: ['message'],
        },
        cb: ({ list }) => {
          if (list.length) {
            const field = list[0].fields.filter(({ name }) => name === 'type');
            this.systemMessageTypeList = field[0].select_one_option.options;
          }
        },
      });
    },
    changeMessagingType() {
      if (this.needWecom && this.form.messagingType.length > 1) {
        this.form.wecomMsgType = 'text';
      }
      if (!this.needEmail || (this.needEmail && this.form.messagingType.length > 1)) {
        this.form.editorType = 1;
      }
    },
    openPreview() {
      this.$refs.previewBox.show({
        title: '预览',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.previewBox.close,
      });
    },
    async handleGetTmpl() {
      try {
        if (this.form.sms_template_id && this.canGetSmsTpl) {
          this.tpmlLoading = true;
          const res = await this.$request({
            url: this.$api.GetSmsTemplate,
            data: {
              sms_template_id: this.form.sms_template_id,
            },
          });
          this.form.templateVars = (this.getAllMatches(res.template_content) || []).reduce(
            (pre, v) => {
              pre[v] = '';
              return pre;
            },
            {},
          );
          this.form.content = res.template_content;
          this.currentTpl[this.form.sms_template_id] = res;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.tpmlLoading = false;
      }
    },
    getAllMatches(str) {
      const regex = /\{\d+\}/g;
      const matches = str.match(regex);
      return matches;
    },
    handleVar(e, item) {
      this.form.templateVars[item] = e;
      this.form.templateVars = { ...this.form.templateVars };
    },
    openHelp() {
      this.$refs.helpBox.show({
        title: '帮助',
        width: '960px',
        top: '30vh',
        confirmText: '返回',
        exitButton: true,
        confirmAction: this.$refs.helpBox.close,
      });
    },
    changeEditorType: _.debounce(function (val) {
      if (this.form.content) {
        this.$message.error('请先清空当前内容，再进行切换');
      } else {
        this.form.editorType = val;
      }
    }, 100),
    handleSmsTpl() {
      const smsTpl = this.currentTpl[this.form.sms_template_id];
      if (!smsTpl) {
        this.form.templateVars = {};
        this.form.content = '';
      } else {
        this.form.templateVars = (this.getAllMatches(smsTpl.template_content) || []).reduce(
          (pre, v) => {
            pre[v] = '';
            return pre;
          },
          {},
        );
        this.form.content = smsTpl.template_content;
      }
    },
    validateContent() {
      if (this.needPlatform) {
        const platformFlagMap = { 1: 'wx', 2: 'web', 3: 'h5' };
        const platforms = (this.form.platform || []).map((item) => platformFlagMap[item]);
        const { content } = this.form;
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const links = doc.querySelectorAll('a');
        const hrefs = Array.from(links).map(function (link) {
          return link.getAttribute('href');
        });
        if (hrefs.length) {
          for (let i = 0; i < hrefs.length; i++) {
            const href = hrefs[i];
            const regex = /\[\(([a-zA-Z0-9]+)\).*?\]/g;
            let match;
            const plats = [];
            while ((match = regex.exec(href)) !== null) {
              plats.push(match[1]);
            }
            // 如果勾选了，而没有配对应平台的链接，则报错
            if (_.difference(platforms, plats).length) {
              return new Error('请确保为每个选中的终端填写对应的链接。');
            }
            if (_.difference(plats, platforms).length) {
              return new Error('请选择超链接对应的通知终端。');
            }
          }
        }
      }
      return null;
    },
  },
};
